import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Owners_ModuleContextService } from './Owners.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Owners_owners_by_status_widget_ComponentContextService {
  private readonly moduleContext: Owners_ModuleContextService;

  constructor(moduleContext: Owners_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'owners_by_status_widget',
      type: ComponentType.widget
    }
  }
}